import { repository } from '@/api/base'

export default {
  async getLessonsForWeekByFilter(filters) {
    const { data } = await repository.post('/xlsxLesson/findLessonsForWeekByFilter', filters)
    return data
  }
}
